const o={path:"/api/v1/plugins/moonpay_on_ramp/sign",method:"POST"};export{o as MoonpayOnRampSign};
